import request from '@/utils/request';

export default {
  list() {
    return request.get('project/list');
  },
  create(name) {
    return request.post('project/create', {
      name,
    });
  },
  delete(id) {
    return request.post('project/delete', {
      id,
    });
  },
  rename(id, newName) {
    return request.post('project/rename', {
      id,
      name: newName,
    });
  },
  copy(id) {
    return request.post('project/copy', {
      id,
    });
  },
  /**
   * description: 开始工程面板
   * author: wkb
   * @param projectId
   * @returns {*|Promise<any>}
   */
  start(projectId) {
    return request.post('project/start', {
      projectId,
    });
  },
  /**
   * description: 结束工程面板
   * author: wkb
   * @param projectId
   * @returns {*|Promise<any>}
   */
  stop(projectId) {
    return request.post('project/stop', {
      projectId,
    });
  },
};



// WEBPACK FOOTER //
// ./src/api/project.js